import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-inline-icon-wrapper',
  template: '<ng-content />',
  styleUrls: ['./inline-icon-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineIconWrapperComponent {

}
